import { memo } from 'react';

import { CheckoutContributionConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { StateFormReturnType } from 'src/utils/stateForm';
import { CheckoutContributionConfirmationFormValues } from 'src/pages/Checkout/ContributionConfirmation/index';
import { UiCleanInput } from 'src/components/UI/inputs/CleanInput';
import { UiCard } from 'src/components/UI/Card';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  model: CheckoutContributionConfirmationResponseType['SpecialInstructionsSubsection'];
  formProps: StateFormReturnType<CheckoutContributionConfirmationFormValues>;
};

export const CheckoutConfirmationSpecialInstructions = memo<Props>(({ model, formProps }) => {
  const tHelper = useTHelper('checkout.confirmation.specialInstructions');

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <UiCard>
        <p className="text-center">
          {tHelper('question', { singular: model.ProjectTerminology.Singular?.toLowerCase() || '' })}
        </p>
        <UiCleanInput
          name="SpecialInstructions"
          formProps={formProps}
          placeholder={tHelper('placeholder')}
          disabled={!model.CanEdit}
        />
      </UiCard>
    </>
  );
});
